// Fixed dice use their actual six faces throughout the physical throw.
export const DICE = [
  {
    id: 'rupture',
    name: 'Rupture',
    label: 'High risk',
    faces: [0, 0, 0, 80, 90, 100],
    description: 'Half the faces are 0. The rest hit 80–100.',
    color: '#ff647c',
    body: '#3a0c20',
    emissive: '#a51b3d',
    metalness: 0.86,
    roughness: 0.3,
  },
  {
    id: 'aegis',
    name: 'Aegis',
    label: 'Low risk',
    faces: [30, 36, 42, 48, 54, 60],
    description: 'A steady 30–60. No empty faces.',
    color: '#6fffe0',
    body: '#093d37',
    emissive: '#14876c',
    metalness: 0.45,
    roughness: 0.16,
  },
  {
    id: 'equinox',
    name: 'Equinox',
    label: 'Balanced',
    faces: [0, 20, 40, 60, 80, 100],
    description: 'The full spectrum, in even steps of 20.',
    color: '#ffd778',
    body: '#453015',
    emissive: '#96631b',
    metalness: 0.95,
    roughness: 0.22,
  },
  {
    id: 'chaos',
    name: 'Chaos',
    label: 'Random',
    faces: null,
    description: 'Every face randomizes from 1–100.',
    color: '#c49bff',
    body: '#281247',
    emissive: '#6e35b8',
    metalness: 0.62,
    roughness: 0.12,
  },
];

export const DEFAULT_DIE = 'chaos';
export const getDie = (id) => DICE.find((die) => die.id === id) || DICE[3];
export const getAttackDieFaceValues = (dieId, damage, faceValues) => {
  const faces =
    faceValues?.length === 6
      ? faceValues
      : getDie(dieId).faces || Array(6).fill('?');
  return faces.map((value, index) => (index === 0 ? damage : value));
};
export const formatDieValue = (value) => {
  if (Number.isInteger(value)) return String(value);
  if (typeof value === 'string' && /^\d+$/.test(value))
    return String(Number(value));
  return String(value ?? '??');
};

export const getDieFaceLabel = (id) =>
  getDie(id).faces?.join(' · ') || 'Six random faces · 1–100';

export const rollDie = (id, random = Math.random) => {
  const { faces } = getDie(id);
  return faces
    ? faces[Math.floor(random() * faces.length)]
    : Math.floor(random() * 100) + 1;
};

export const isValidDieRoll = (value, id) => {
  if (!Number.isInteger(value)) return false;
  const { faces } = getDie(id);
  return faces ? faces.includes(value) : value >= 1 && value <= 100;
};

export const selectDie = (game, id) =>
  ['ready', 'bossReady'].includes(game.phase) &&
  DICE.some((die) => die.id === id) &&
  game.selectedDie !== id
    ? {
        ...game,
        selectedDie: id,
        ...(game.phase === 'bossReady'
          ? {
              coreDieFaces: [
                ...(getDie(id).faces ||
                  Array.from({ length: 6 }, () => rollDie(id))),
              ],
            }
          : {}),
      }
    : game;
